import type { StatusMeta } from '@/lib/statusMap';

interface StatusBadgeProps {
  meta: StatusMeta;
  showDot?: boolean;
}

export default function StatusBadge({ meta, showDot = true }: StatusBadgeProps) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-2.5 py-1 text-xs font-semibold ${meta.classes}`}
    >
      {showDot && <span className={`h-1.5 w-1.5 rounded-full ${meta.dot}`} />}
      {meta.label}
    </span>
  );
}